/** Municipality configuration API (BC-3). super_admin passes municipalityId. */
import apiClient from '@/services/api/client';

const p = (municipalityId) => (municipalityId ? { municipality_id: municipalityId } : {});

export const getConfig = async (municipalityId) =>
        (await apiClient.get('/v1/config', { params: p(municipalityId) })).data;
export const updateConfig = async (body, municipalityId) =>
        (await apiClient.put('/v1/config', body, { params: p(municipalityId) })).data;
export const getPublicConfig = async () => (await apiClient.get('/v1/public/config')).data;
